// This file automatically generated by skymarshal.
// DO NOT MODIFY BY HAND!!!!
//
// From Source File: tools/lcmtype_auto_translation/lcmtypes/flight_deck.legacy_15561678412280274150_battery_prediction_t.lcm

import { float } from "@skydio/lcm/src/types";
import { int64_t } from "@skydio/lcm/src/types";

import Long from "long";
import Decoder from "@skydio/lcm/src/decoder";
import Encoder from "@skydio/lcm/src/encoder";
import LcmMsg from "@skydio/lcm/src/lcm";
import ReflectionMeta from "@skydio/lcm/src/reflection";

export class legacy_15561678412280274150_battery_prediction_t extends LcmMsg {

  private static _hash = Long.fromString("7780839206140137075", true);
  private static _packed_fingerprint?: Long;

  /** @internal */
  public static override _get_packed_fingerprint(): Long {
    if (legacy_15561678412280274150_battery_prediction_t._packed_fingerprint === undefined) {
      legacy_15561678412280274150_battery_prediction_t._packed_fingerprint = legacy_15561678412280274150_battery_prediction_t._get_hash_recursive([]);
    }
    return legacy_15561678412280274150_battery_prediction_t._packed_fingerprint;
  }

  /** @internal */
  public static override _get_hash_recursive(parents: any[]): Long {
    if (parents.indexOf(legacy_15561678412280274150_battery_prediction_t) > -1) {
      return Long.fromNumber(0, true);
    }
    let tmp_hash = legacy_15561678412280274150_battery_prediction_t._hash;
    return tmp_hash.shl(1).add(tmp_hash.shru(63));
  }

  /** @internal */
  public static override _reflection_meta: ReflectionMeta = {
    utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    predicted_low_land_utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    predicted_critical_utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    predicted_battery_hot_utime: { kind: "primitive", type: Number, typeStr: "int64_t" },
    battery_percentage: { kind: "primitive", type: Number, typeStr: "float" },
    battery_charging: { kind: "primitive", type: Boolean, typeStr: "boolean" },
    true_battery_percentage: { kind: "primitive", type: Number, typeStr: "float" },
    predicted_return_percentage: { kind: "primitive", type: Number, typeStr: "float" },
    predicted_critical_percentage: { kind: "primitive", type: Number, typeStr: "float" },
  };

  public utime: int64_t;
  public predicted_low_land_utime: int64_t;
  public predicted_critical_utime: int64_t;
  public predicted_battery_hot_utime: int64_t;
  public battery_percentage: float;
  public battery_charging: boolean;
  public true_battery_percentage: float;
  public predicted_return_percentage: float;
  public predicted_critical_percentage: float;

  public override decode(byte_array: Uint8Array): legacy_15561678412280274150_battery_prediction_t {
    const decoder = new Decoder(new DataView(
      byte_array.buffer, byte_array.byteOffset, byte_array.byteLength
    ));
    const hash = decoder.decode_hash();
    if (!hash.equals(legacy_15561678412280274150_battery_prediction_t._get_packed_fingerprint())) {
      console.error("Hash mismatch", hash, legacy_15561678412280274150_battery_prediction_t._get_packed_fingerprint());
      throw new Error("Hash mismatch!");
    }
    this.decode_one(decoder);
    return this;
  }

  public override decode_one(decoder: Decoder): legacy_15561678412280274150_battery_prediction_t {
    this.utime = decoder.decode_int64_t();
    this.predicted_low_land_utime = decoder.decode_int64_t();
    this.predicted_critical_utime = decoder.decode_int64_t();
    this.predicted_battery_hot_utime = decoder.decode_int64_t();
    this.battery_percentage = decoder.decode_float();
    this.battery_charging = decoder.decode_boolean();
    this.true_battery_percentage = decoder.decode_float();
    this.predicted_return_percentage = decoder.decode_float();
    this.predicted_critical_percentage = decoder.decode_float();
    return this;
  }

  /** @internal */
  public _get_encoded_size(): number {
    let total_size = 0;
    total_size += 8;
    total_size += 8;
    total_size += 8;
    total_size += 8;
    total_size += 4;
    total_size += 1;
    total_size += 4;
    total_size += 4;
    total_size += 4;
    return total_size;
  }

  public override encode(): ArrayBufferLike {
    const encoder = new Encoder(8 + this._get_encoded_size()); // hash + rest
    encoder.encode_hash(legacy_15561678412280274150_battery_prediction_t._get_packed_fingerprint());
    this.encode_one(encoder);

    return encoder.view.buffer;
  }

  public override encode_one(encoder: Encoder): void {
    encoder.encode_int64_t(this.utime);
    encoder.encode_int64_t(this.predicted_low_land_utime);
    encoder.encode_int64_t(this.predicted_critical_utime);
    encoder.encode_int64_t(this.predicted_battery_hot_utime);
    encoder.encode_float(this.battery_percentage);
    encoder.encode_boolean(this.battery_charging);
    encoder.encode_float(this.true_battery_percentage);
    encoder.encode_float(this.predicted_return_percentage);
    encoder.encode_float(this.predicted_critical_percentage);
  }

  constructor(init?: {utime?: int64_t, predicted_low_land_utime?: int64_t, predicted_critical_utime?: int64_t, predicted_battery_hot_utime?: int64_t, battery_percentage?: float, battery_charging?: boolean, true_battery_percentage?: float, predicted_return_percentage?: float, predicted_critical_percentage?: float }) {
    super();
    this.utime = 0;
    this.predicted_low_land_utime = 0;
    this.predicted_critical_utime = 0;
    this.predicted_battery_hot_utime = 0;
    this.battery_percentage = 0.0;
    this.battery_charging = false;
    this.true_battery_percentage = 0.0;
    this.predicted_return_percentage = 0.0;
    this.predicted_critical_percentage = 0.0;

    // optionally override default values
    if (!init) {
      return;
    }
    this.utime = init.utime || this.utime;
    this.predicted_low_land_utime = init.predicted_low_land_utime || this.predicted_low_land_utime;
    this.predicted_critical_utime = init.predicted_critical_utime || this.predicted_critical_utime;
    this.predicted_battery_hot_utime = init.predicted_battery_hot_utime || this.predicted_battery_hot_utime;
    this.battery_percentage = init.battery_percentage || this.battery_percentage;
    this.battery_charging = init.battery_charging || this.battery_charging;
    this.true_battery_percentage = init.true_battery_percentage || this.true_battery_percentage;
    this.predicted_return_percentage = init.predicted_return_percentage || this.predicted_return_percentage;
    this.predicted_critical_percentage = init.predicted_critical_percentage || this.predicted_critical_percentage;
  }
}